import React from 'react'

import UiContainer from './UiContainer'

export default function ui(uiState) {
  return WrappedComponent => props => (
    <UiContainer uiState={uiState} WrappedComponent={WrappedComponent} {...props} />
  )
}
